"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfProductPromotionsMaterialBatchUpdateModel = instanceOfProductPromotionsMaterialBatchUpdateModel;
exports.ProductPromotionsMaterialBatchUpdateModelFromJSON = ProductPromotionsMaterialBatchUpdateModelFromJSON;
exports.ProductPromotionsMaterialBatchUpdateModelFromJSONTyped = ProductPromotionsMaterialBatchUpdateModelFromJSONTyped;
exports.ProductPromotionsMaterialBatchUpdateModelToJSON = ProductPromotionsMaterialBatchUpdateModelToJSON;
exports.ProductPromotionsMaterialBatchUpdateModelToJSONTyped = ProductPromotionsMaterialBatchUpdateModelToJSONTyped;
/**
 * Check if a given object implements the ProductPromotionsMaterialBatchUpdateModel interface.
 */
function instanceOfProductPromotionsMaterialBatchUpdateModel(value) {
    return true;
}
function ProductPromotionsMaterialBatchUpdateModelFromJSON(json) {
    return ProductPromotionsMaterialBatchUpdateModelFromJSONTyped(json, false);
}
function ProductPromotionsMaterialBatchUpdateModelFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'wsppmPromotionsNo': json['wsppmPromotionsNo'] == null ? undefined : json['wsppmPromotionsNo'],
        'calculationType': json['calculationType'] == null ? undefined : json['calculationType'],
        'calculationValue': json['calculationValue'] == null ? undefined : json['calculationValue'],
    };
}
function ProductPromotionsMaterialBatchUpdateModelToJSON(json) {
    return ProductPromotionsMaterialBatchUpdateModelToJSONTyped(json, false);
}
function ProductPromotionsMaterialBatchUpdateModelToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'wsppmPromotionsNo': value['wsppmPromotionsNo'],
        'calculationType': value['calculationType'],
        'calculationValue': value['calculationValue'],
    };
}
